import { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { Box, Button, Image, Text, Toast } from '@bonanza-social/moonlight';
import {
  setPromptShown,
  enableBiometrics,
  selectBiometricsType,
} from '../../../state/biometrics/biometrics.slice';

function BiometricLogin({ close }: BottomSheetExtendedProps) {
  const [t] = useTranslation('auth');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const biometryType = useSelector(selectBiometricsType);

  const handleButtonPress = useCallback(async () => {
    setLoading(true);

    const response = await dispatch(enableBiometrics());

    if (response.meta.requestStatus === 'fulfilled') {
      setTimeout(() => {
        Toast.show({
          type: 'success',
          text: t('biometricsEnabled', { context: biometryType }),
        });
      }, 1000);

      close();
    }

    setLoading(false);
  }, [biometryType, close, dispatch, t]);

  useEffect(() => {
    dispatch(setPromptShown(true));
  }, [dispatch]);

  return (
    <Box paddingTop="space-600" gap="space-600">
      <Box flexDirection="row" gap="space-200">
        <Image name="auth.biometricLock" width={75} height={75} />
        <Text
          locNS="auth"
          locKey="biometricLoginDescription"
          alignSelf="center"
          color="darkSurfacePrimary"
          variant="body-s"
          flex={1}
        />
      </Box>
      <Button
        locNS="auth"
        locKey="biometricLoginButton"
        loading={loading}
        marginTop="auto"
        onPress={handleButtonPress}
      />
    </Box>
  );
}

export default memo(BiometricLogin);
